import { Component } from 'react'
import Octicon, { Location } from '@primer/octicons-react'
import styles from '~/styles/ordersPage.deliveryProperties.module.css'
import types from '~/types/ordersPage.ts'

export default class DeliveryProperties extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'Orders', 'common' ],
		}
	}
	
	constructor(props) {
		super(props)
	}
	
	render(): JSX.Element {
		let selectedPointNumber = 0
		if (this.props.order.selectedPointNumber && typeof this.props.order.selectedPointNumber === 'number') {
			selectedPointNumber = this.props.order.selectedPointNumber
		}
		let points = this._getPoint()
		if (this.props.order.points) {
			points = [this._getPoint(0, selectedPointNumber), this._getPoint(1, selectedPointNumber), this._getPoint(2, selectedPointNumber)]
		}
		if (this.props.arePointsLoading) {
			return this._getSpinner()
		} else {
			if (points && (!points.length || points[0])) {
				return (
					<div
						className={(points.length ? styles.points : styles.onePoint)}
					>
						{points}
					</div>
				)
			} else {
				let resultSign = this.props.t('Please, select the location')
				if (this.props.order.noPoints || !this.props.order.points?.length) {
					resultSign = this.props.t('No nearby locations found, please continue typing the Full Address')
				}
				return (
					<div
						className={styles.noPoint}
					>
						<div>
							<Octicon
								icon={Location}
								size="medium"
							/>
						</div>
						<div>
							{this.props.isEmptyResult ? this.props.t('Please fill out the required fields') : resultSign}
						</div>
						<div
							className={styles.button}
							onClick={this._onCheckOnMap.bind(this)}
						>
							{this.props.t('Find on Map')}
						</div>
					</div>
				)
			}
		}
	}
	
	private _getPoint(pointNumber, selectedPointNumber): JSX.Element | null {
		let show = false
		let point = null
		if (typeof pointNumber === 'number') {
			if (this.props.order.points) {
				if (pointNumber < this.props.order.points.length) {
					point = this.props.order.points[pointNumber]
					show = true
				}
			}
		} else {
			show = true
		}
		const dealerDeliveryPrice = this._getDeliveryCost(point)
		const customerDeliveryPrice = point?.price_base
		if (show && this.props.order.in_point) {
			const isSelected = (pointNumber === selectedPointNumber)
			return (
				<div
					className={styles.point + (isSelected ? (' ' + styles.selected) : '')}
					onClick={this._onClick.bind(this, pointNumber, point?.id)}
					key={point?.id || pointNumber}
				>
					<div>
						<Octicon
							icon={Location}
							size="medium"
						/>
					</div>
					<div>
						<div>
							{this._getPointName(point)}
						</div>
						<div>
							{this._getPointAddress(point)}
						</div>
						<div>
							{this._getPointInfo(point)}
						</div>
						<div>
							{this._getZoneAndFuel(point)}
						</div>
					</div>
					<div
						className={styles.deliveryPrices}
					>
						<div
							className={styles.dealerDeliveryPrice}
						>
							{this._getPriceWithCurrency(dealerDeliveryPrice)}
						</div>
						<div
							className={styles.customerDeliveryPrice}
						>
							{typeof customerDeliveryPrice !== 'undefined' ? this._getPriceWithCurrency(customerDeliveryPrice) : null}
						</div>
					</div>
					<div>
						<div
							className={styles.button}
							onClick={this._onShowOnMap.bind(this, pointNumber)}
						>
							{this.props.t('Show on Map')}
						</div>
					</div>
					<div
						className={(!isSelected ? styles.hidden : null)}
					>
						{this.props.t('Selected Location')}
					</div>
				</div>
			)
		} else {
			return null
		}
	}
	
	private _getPointName(point): string {
		if (point) {
			return point.description
		} else {
			return this.props.order.pointDescription || this.props.order.point_description
		}
	}
	private _getPointAddress(point): string {
		if (point) {
			return point.full_address
		} else {
			return this.props.order.pointAddress || this.props.order.point_address
		}
	}
	private _getPointInfo(point): string {
		if (point) {
			let isNumerous = true
			let days = `${point.min_days} – ${point.max_days}`
			if (point.min_days === point.max_days || !point.min_days) {
				days = point.max_days
				if (point.max_days === 1) {
					isNumerous = false
				}
			}
			let pointInfoEn = ''
			if (point.min_days && point.max_days) {
				pointInfoEn += `Expected delivery time: ${days} business days.`
			}
			if (point.distance) {
				pointInfoEn += ` Distance to the pick-up location: `
				if (point.distance < 322) {
					pointInfoEn += `${(point.distance * 3.28084).toFixed() + ' feet.'}`
				} else {
					pointInfoEn += `${(point.distance/1609.34).toFixed(1) + ' miles.'}`
				}
			}
			let pointInfoRu = ''
			if (point.max_days) {
				pointInfoRu += `Ожидаемый срок доставки: ${days} дн${isNumerous ? 'я' : 'ей'}.`
			}
			if (point.distance) {
				pointInfoRu += ` Расстояние до точки выдачи: `
				if (point.distance < 1000) {
					pointInfoRu += `${(point.distance).toFixed() + ' м.'}`
				} else {
					pointInfoRu += `${(point.distance/1000).toFixed(1) + ' км.'}`
				}
			}
			let pointInfo = pointInfoEn
			if (this.props.isRu) {
				pointInfo = pointInfoRu
			}
			return pointInfo
		} else {
			return ''
		}
	}
	private _getZoneAndFuel(point): string {
		if (+(point?.fuel_surcharge) > 0) {
			return (
				<>
					<div>
						{this.props.t('Fuel surcharge')}: {this._getPriceWithCurrency(point?.fuel_surcharge)},
					</div>
					<div>
						{this.props.t('zone')}: {point?.zone || ''}
					</div>
				</>
			)
		} else {
			return null
		}
	}
	
	private _getDeliveryCost(point): string {
		let deliveryCost = this.props.order.in_delivery_cost
		if (point) {
			deliveryCost = point.price
		}
		return deliveryCost
	}

	private _getPriceWithCurrency(price): string {
		let priceString = (+(price)).toFixed(2)
		if (priceString) {
			const currencySign = this.props.t(this.props.order.currency + ' Sign')
			if (this.props.order.currency === 'RUB') {
				priceString += currencySign
			} else {
				priceString = currencySign + priceString
			}
		}
		return priceString || ''
	}
	
	private _onClick(pointNumber, pointId, event): void {
		const isShowOnMap = event.target.classList.value.includes('deliveryProperties_button')
		if (!isShowOnMap) {
			this.props.editTheOrder({
				selectedPointNumber: pointNumber,
				selectedPointId: pointId,
				'in_point': pointId,
			})
			setTimeout(() => {
				this.props.chargeableWeightUpdater()
			})
		}
	}
	
	private _onCheckOnMap(): void {
		this.props.showMap(null, 'locationCheckOnMap')
	}
	
	private _onShowOnMap(pointNumber): void {
		this.props.showMap(pointNumber, 'onShowOnMap')
	}

	private _getSpinner(): JSX.Element {
		let content: Array<JSX.Element> = []
			content.push(this._getLoading(0))
			content.push(this._getLoading(1))
			content.push(this._getLoading(2))
		return (
			<div
				className={styles.waiting}
			>
				{content}
			</div>
		)
	}

	private _getLoading(i): JSX.Element | null {
		let divs: Array<JSX.Element> = []
		for (let j = 0; j < 9; j++) {
			divs.push(( <div key={j}/> ))
		}
		return (
			<div
				key={i}
				className={styles.loadingGrid}
			>
				{divs}
			</div>
		)
	}
}